import { type ReactNode, type RefObject } from "react"
import { Loader2, Plus } from "lucide-react"
import { cn } from "@/lib/utils"

export type AddDashedTileProps = {
  onClick: () => void
  disabled?: boolean
  uploading?: boolean
  ariaLabel: string
  ariaPressed?: boolean
  className?: string
  buttonRef?: RefObject<HTMLButtonElement | null>
  /** When set, shown instead of the Plus icon (e.g. "3D"). */
  label?: string
  /** When set, shown instead of the Plus icon (e.g. <Images />). */
  icon?: ReactNode
  title?: string
}

/** Dashed square add tile — refs strip, heroes strip, and similar. */
export function AddDashedTile({
  onClick,
  disabled = false,
  uploading = false,
  ariaLabel,
  ariaPressed,
  className,
  buttonRef,
  label,
  icon,
  title,
}: AddDashedTileProps) {
  return (
    <button
      ref={buttonRef}
      type="button"
      disabled={disabled || uploading}
      onClick={onClick}
      title={title}
      className={cn(
        "flex h-16 w-16 shrink-0 items-center justify-center rounded-lg border border-dashed border-ui-border-strong text-ui-text-muted transition-colors hover:border-ui-accent hover:text-ui-link",
        (disabled || uploading) && "pointer-events-none opacity-50",
        className,
      )}
      aria-label={ariaLabel}
      aria-pressed={ariaPressed}
    >
      {uploading ? (
        <Loader2 className="h-4 w-4 animate-spin" />
      ) : label ? (
        <span className="leading-none font-medium">{label}</span>
      ) : icon ? (
        icon
      ) : (
        <Plus
          className={cn("h-5 w-5 transition-transform duration-200 ease-out", ariaPressed && "rotate-45")}
          aria-hidden
        />
      )}
    </button>
  )
}
